import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProductsService} from '../services/products.service';
import {ChartEvent, ChartOptions} from 'chart.js';
import {ActivatedRoute, Router} from '@angular/router';
import {forkJoin, Subject} from 'rxjs';
import {PriceRobotFilter} from "../services/price-robot-filter";

@Component({
    selector: 'app-price-graphs',
    templateUrl: './price-graphs.component.html',
    styleUrls: ['./price-graphs.component.scss'],
    providers: [ProductsService]
})
export class PriceGraphsComponent implements OnInit {
    @Input() filter: PriceRobotFilter = null;
    @Input() refresh: Subject<boolean> = new Subject<boolean>();
    deviations: any;
    categories: any;
    // Category
    public categoryChartLabels = [];
    public categoryChartOptions: ChartOptions<'pie'> = {
        responsive: false,
    };
    public categoryChartDatasets = [];
    public categoryChartLegend = true;
    public categoryChartPlugins = [];

    // Deviation
    public deviationChartLabels = [];
    public deviationChartOptions: ChartOptions<'bar'> = {
        responsive: false,
    };
    public deviationChartDatasets = [];
    public deviationChartLegend = false;
    public deviationChartPlugins = [];

    constructor(
        public productsService: ProductsService,
        private router: Router,
        private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.refresh.subscribe(response => {
            this.loadData();
        });
        this.loadData();
    }

    loadData() {
        forkJoin(
            this.productsService.getDeviationGraphData(this.filter),
            this.productsService.getCategoryGraphData(this.filter),
        ).subscribe(data => {
            this.deviations = data[0];
            this.categories = data[1];
            this.updateChart();
        });
    }

    updateChart() {
        // Categories
        // @todo procent i stedet for total?
        // @todo find sum
        const categoryData = [];
        this.categoryChartLabels = ['Billigst', 'Samme', 'Dyrere', 'Dyrest']
        let i = 0;
        this.categoryChartLabels.forEach((label) => {
            if (this.categories.data[label]) {
                categoryData[i] = this.categories.data[label].length;
            } else {
                categoryData[i] = 0;
            }
            i++;
        });

        this.categoryChartDatasets = [{
            data: categoryData,
            backgroundColor: ['green', 'blue', '#e8e81a', 'red'],
            color: ['green', 'blue', '#e8e81a', 'red'],
            hoverBackgroundColor: ['green', 'blue', '#e8e81a', 'red'],
            hoverBorderColor: ['green', 'blue', '#e8e81a', 'red']
        }];

        // Deviations
        const labels = [];
        const deviations = [];
        i = 0;
        for (const deviation of this.deviations.data) {
            labels[i] = deviation.range;
            deviations[i] = deviation.products;
            i++;
        }

        labels.unshift('-100');
        deviations.unshift(this.deviations.under[0].products)

        labels.push('100+');
        deviations.push(this.deviations.over[0].products)

        this.deviationChartLabels = labels;
        this.deviationChartDatasets = [{
            data: deviations,
            backgroundColor: ['green'],
            hoverBackgroundColor: ['green'],
        }];
    }

    public chartClicked({event, active}: { event?: ChartEvent, active?: { index: string; }[] }
        , type: string): void {
        if (active[0]) {
            if (type === 'deviation') {
                if (this.deviationChartLabels[active[0].index] === '-100') {
                    this.router.navigateByUrl('/price-robot/products?page=1&filter=' +
                        '{"minDeviation":"0" ,"maxDeviation":"-100"}');
                    return;
                } else if (this.deviationChartLabels[active[0].index] === '100+') {
                    this.router.navigateByUrl('/price-robot/products?page=1&filter=' +
                        '{"minDeviation":"' + '100' + '" ,"maxDeviation":"' + '0' + '"}');
                    return;
                }
                const labels = this.deviationChartLabels[active[0].index].split('/');

                this.router.navigateByUrl('/price-robot/products?page=1&filter=' +
                    '{"minDeviation":"' + labels[0] + '" ,"maxDeviation":"' + labels[1] + '"}');
            } else if (type === 'category') {
                this.router.navigateByUrl('/price-robot/products?page=1&filter=' +
                    '{"selectedPriceCategory":"' + this.categoryChartLabels[active[0].index] + '"}');
            }
        }
    }
}
